import { em } from 'polished'
import styled, { css } from 'styled-components'

export const FrameMacStraightDynamic = styled.div`
  position: relative;
  width: ${em(693)};
  max-width: 180%;

  ${p => p.theme.mq.upMd} {
    max-width: none;
  }
`

export const LaptopImg = styled.img`
  width: 100%;
  height: auto;
`

export const Frame = styled.div`
  position: absolute;
  left: 12.6%;
  top: 7.2%;
  width: 75.2%;
  height: 81.3%;
  overflow: hidden;
`

export const ImageBox = styled.div`
  width: 100%;
  height: 100%;
  opacity: 1;
  transition-property: opacity, transform;
  transition-duration: ${p => p.theme.animation.timeBtns};
  overflow: hidden;

  ${({ transitionState }) =>
    transitionState === 'entering' &&
    css`
      opacity: 0;
      transform: translateY(${em(40)});
      transition-duration: 0s;
      z-index: 1;
    `}

  ${({ transitionState }) =>
    transitionState === 'entered' &&
    css`
      opacity: 1;
      transform: translateY(0);
      transition-duration: ${p => p.theme.animation.timeBtns};
    `}

  ${({ transitionState }) =>
    (transitionState === 'exiting' || transitionState === 'exited') &&
    css`
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      transform: translateY(20%);
      z-index: 2;
    `}
`
